module.exports = __webpack_public_path__ + "assets/5aac71bb58714783ffb679cd364fbe33.mp3";